module.exports = __webpack_public_path__ + "img/8-1_Factor_Check.a11eaa76.png";